import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Dialog, DialogActions, DialogDescription, DialogTitle } from "src/components/base/dialog";
import { Button } from "../base/button";
import { ApiInternal } from "src/api/api_internal";
import { FullDevice } from "src/api/generated/frontend_internal_v1";

/**
 * The properties for {@link DeleteDeviceDialog}
 */
export type DeleteDeviceDialogProps = {
    /** Callback for closing the popup */
    onClose: () => void;

    /** Callback for successful deletion */
    onDeletion: () => void;

    /** The device */
    device: FullDevice;
};

/**
 * A dialog to delete a device
 */
export default function DeleteDeviceDialog(props: DeleteDeviceDialogProps) {
    const [t] = useTranslation("dialog-delete-device");
    const [tg] = useTranslation();

    /**
     * Delete a device
     */
    const deleteDevice = async () => {
        await ApiInternal.devices.deleteDevice(props.device.uuid);
        toast.success(t("toast.device-deleted-successfully"));
        props.onDeletion();
    };

    return (
        <Dialog open={true} onClose={props.onClose}>
            <DialogTitle>{t("heading.delete-device", { device: props.device.dnsname })}</DialogTitle>
            <DialogDescription>{t("description.delete-device")}</DialogDescription>
            <DialogActions>
                <Button onClick={props.onClose}>{tg("button.cancel")}</Button>
                <Button color={"red"} onClick={async () => await deleteDevice()}>
                    {t("button.delete-device")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
